import { DataTable } from './DataTable'
import { Button } from 'antd'
import { YhBox } from '@/components/YhBox'
import { threeInspectionAlcoholDrivingModel } from '../alcoholDrivingModel'
import { ExportOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { exportListData } = threeInspectionAlcoholDrivingModel()

    const action = (
        <>
            <Button style={{ marginBottom: '5px' }} shape="round" type="link" onClick={() => exportListData()}>
                <ExportOutlined />
                导出
            </Button>
        </>
    )

    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}
